import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';

export const dictionaryIdByName: Record<DictionaryNamesEnum, string> = {
  [DictionaryNamesEnum.ACCEPTED_DOCUMENT]: '9b34987a-fef9-47b4-a25b-83ab9402f0ff',
  [DictionaryNamesEnum.CHECKLIST]: '10b37e38-b975-11eb-8529-0242ac130003',
  [DictionaryNamesEnum.EVENT_TYPE]: 'f0f9a79a-a5b3-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.PM_PROF_EVENT_TYPE]: 'f0f9a79a-a5b3-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.KNM_KIND]: 'd2ec803a-a53e-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.DECISION_KIND]: '414abd43-eb02-4373-aba1-71d63aba4f8d',
  [DictionaryNamesEnum.DECISION_KIND_ALL]: '414abd43-eb02-4373-aba1-71d63aba4f8d',
  [DictionaryNamesEnum.KNO_ORGANIZATIONS]: 'af002594-a4f0-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.PROF_KIND]: 'e8703904-a545-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.REQUIREMENT]: 'a43f056e-b95c-11eb-8529-0242ac130003',
  [DictionaryNamesEnum.RISK_CATEGORY]: '18d790d4-a5a9-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.DANGER_CLASS]: 'aae78350-bdfd-12eb-8529-0242ac130003',
  [DictionaryNamesEnum.RISK_INDICATORY]: '1afc36ea-ba6b-11eb-8529-0242ac130003',
  [DictionaryNamesEnum.SUBJECT_TYPE]: '641d3956-a5b1-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.SUBJECT_KIND]: '641d3bb8-a5b1-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.SUBJECT_SUB_KIND]: '641d3e60-a5b1-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.SUPERVISION_TYPE]: '1f27d942-a52e-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.SUPERVISION_TYPE_BY_SUBJECT_TYPE]: '1f27d942-a52e-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.FEDERAL_LAWS]: 'ce32a718-0db7-45ce-96dc-33b5918c0d87',
  [DictionaryNamesEnum.KNO_LEVELS]: 'acd38402-3299-4575-a49c-88e00b2b9eb6',
  [DictionaryNamesEnum.KNM_SUBJECT_TYPES]: 'eedb105c-4854-4d7f-82f4-e4ba93b350e7',
  [DictionaryNamesEnum.POSITIONS]: 'b6fc9844-a528-11eb-bcbc-0242ac130002',
  [DictionaryNamesEnum.PERMIT_DOCS]: 'null',
  [DictionaryNamesEnum.PARTICIPANT_POSITIONS]: '003d7ce8-c474-11eb-8529-0242ac130003',
  [DictionaryNamesEnum.ERVK]: 'c903bb33-d544-4d04-9276-15d0b1c39c8c',
  [DictionaryNamesEnum.TARGET_ENTITY]: 'null',
  [DictionaryNamesEnum.TARGET_ENTITY_FOUNDER]: 'null',
  [DictionaryNamesEnum.KNM_TYPES]: 'null',
  [DictionaryNamesEnum.ERVK_CHECK_LIST]: 'null',
  [DictionaryNamesEnum.CONDITION_TYPES]: 'null',
  [DictionaryNamesEnum.APPLICATION_CONDITION_SUBJECTS]: 'null',
  [DictionaryNamesEnum.FEDERAL_LAWS]: 'ce32a718-0db7-45ce-96dc-33b5918c0d87',
};
